var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupertagCulture = function SvgSupertagCulture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M33.147 61.33A10.92 10.92 0 0 1 22.22 72.257 10.92 10.92 0 0 1 11.29 61.329 10.92 10.92 0 0 1 22.22 50.401H61.78A10.92 10.92 0 0 1 72.71 61.329 10.92 10.92 0 0 1 61.78 72.258a10.92 10.92 0 0 1-10.928-10.929V22.614A10.92 10.92 0 0 1 61.78 11.686 10.92 10.92 0 0 1 72.71 22.614 10.92 10.92 0 0 1 61.78 33.543H22.22A10.92 10.92 0 0 1 11.29 22.614 10.92 10.92 0 0 1 22.22 11.686a10.92 10.92 0 0 1 10.928 10.928z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M71.382 2H12.618C6.754 2 2 6.754 2 12.618v58.764C2 77.246 6.754 82 12.618 82h58.764C77.246 82 82 77.246 82 71.382V12.618C82 6.754 77.246 2 71.382 2"
  })));
};
export default SvgSupertagCulture;